import { FormModel } from "../../../utils/FormModel";


export class SystemAlert extends FormModel {
    public value: string = "";
    public origin: string = "";
    public severity: number = 0;
    public timestamp: Date = new Date();
}
